import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { select as select_characteristic_types } from "../characteristic_type";
import { selectByCharacteristicTypeId as select_characteristic_values } from "../characteristic_value";

import { Product as ProductService } from "../../../services/Catalog Management";
import { addTitleOption, createOptions } from "src/utils/select";

const service = new ProductService();

const REDUCER_MODULE_NAME = "PRICE_UPDATE";

const initialState = {
  operations: [],
  formIsReady: false,
  loading: true,
  message: "",
  error: "",
};

/*
  1. Selecciono el characteristic_type
  2. ⁠Selecciono el characteristic_value correspondiente al punto 1.
  3. ⁠Incrementar / Decrementar
  4. ⁠Valor (1 - 100%)
*/

const loadingReducer = (state, _) => {
  return {
    ...state,
    formIsReady: false,
    loading: true,
  };
};

export const form = createAsyncThunk(
  `FORM_${REDUCER_MODULE_NAME}`,
  async (_, { dispatch }) => {
    await dispatch(
      select_characteristic_types({
        base_url: service.base_url,
        leaf: "PRODUCT",
      }),
    );

    return {
      operations: addTitleOption(
        createOptions([
          { id: "+", value: "Incrementar" },
          { id: "-", value: "Decrementar" },
        ]),
      ),
    };
  },
);

export const selectByCharacteristicTypeId = createAsyncThunk(
  `SELECT_CHARACTERISTIC_VALUES_BY_CHARACTERISTIC_TYPE_ID_${REDUCER_MODULE_NAME}`,
  async ({ characteristic_type_id }, { dispatch }) => {
    await dispatch(
      select_characteristic_values({
        base_url: service.base_url,
        characteristic_type_id,
      }),
    );
  },
);

export const submitForm = createAsyncThunk(
  `SUBMIT_FORM_${REDUCER_MODULE_NAME}`,
  async (data) => {
    try {
      await service.priceUpdate(data);

      return {
        error: "",
        message: `Los precios fueron actualizados correctamente.`,
      };
    } catch (error) {
      return {
        error: error.message,
        message: "",
      };
    }
  },
);

export const slice = createSlice({
  name: REDUCER_MODULE_NAME,
  initialState,
  reducers: {
    clean() {
      return {
        ...initialState,
      };
    },
  },
  extraReducers: {
    [form.pending.type]: loadingReducer,
    [submitForm.pending.type]: loadingReducer,

    [form.fulfilled.type]: (state, action) => {
      return {
        ...state,
        loading: false,
        operations: action.payload.operations,
      };
    },
    [submitForm.fulfilled.type]: (state, action) => {
      return {
        ...state,
        loading: false,
        formIsReady: !!action.payload.message,
        message: action.payload.message,
        error: action.payload.error,
      };
    },
  },
});

export const { clean } = slice.actions;

export default slice.reducer;
